<template>
  <DateField v-model="context.value.value[props.field.key]" v-bind="props" />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import DateField from '../DateField.vue'
import type { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()
</script>
